import React from "react";
import { Card, Col } from "react-bootstrap";

/** One card in a "reporting" KPI grid — label, big value, optional color/sub-caption. */
export const ReportStatCard: React.FC<{
  label: string;
  value: number | string;
  color?: string;
  sub?: string;
}> = ({ label, value, color = "dark", sub }) => (
  <Col xs={6} sm={4} md={3} xl>
    <Card className="h-100">
      <Card.Body className="py-2 px-3">
        <div
          className="small fw-semibold mb-1 text-muted"
          style={{
            fontSize: "0.72rem",
            textTransform: "uppercase",
            letterSpacing: "0.04em",
          }}
        >
          {label}
        </div>
        <div className={`fs-4 fw-bold text-${color}`}>{value}</div>
        {sub && (
          <div className="text-muted" style={{ fontSize: "0.7rem" }}>
            {sub}
          </div>
        )}
      </Card.Body>
    </Card>
  </Col>
);
